import apiService from '../index';

class StandingsManager {
  constructor() {
    this.apiService = apiService;
  }

  async fetchStanding(leagueID, season) {
    try {
      
      const response = await this.apiService.getStanding(leagueID, season);
      
      if (response.status === 'error') {
        console.error('Error fetching odds:', response.message);
        return response;
      }
      
      return {
        status: 'success',
        data: response.data,
        endpoint: 'standings',
        params: { leagueID, season },
        fromCache: response.fromCache
      };
    } catch (error) {
      console.error('Error in standings:', error);
      return {
        status: 'error',
        message: error.message,
        endpoint: 'odds'
      };
    }
  }
}

export default new StandingsManager(); 